import { createAction } from 'redux-actions';
import * as types from './types';

export const setCommunity = createAction(types.SET_COMMUNITY);
export const setCommunitySlides = createAction(types.SET_COMMUNITY_SLIDES);
export const setLoadingSlides = createAction(types.SET_LOADING_SLIDES);
